import { MutationToasts, useMutation } from '~/api/api-client'

export const USER_QUERY_KEYS = ['users', 'me', 'send-alert-email']
const url = '/users/me/send-alert-email'

export const useSendAlertEmail = (toasts: MutationToasts = {}) => {
  return useMutation<void>({
    method: 'post',
    url,
    collectionKeys: USER_QUERY_KEYS,
    ...toasts,
  })
}
